import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import LevelItem from './LevelItem';

function LevelsList({ levels, isLoading, onDragEnd, onRemove, onInput, setHasError }) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-16 rounded-lg bg-muted animate-pulse" />
        ))}
      </div>
    );
  }

  if (levels.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No levels defined yet.</p>
        <p className="text-sm mt-1">Click &quot;Add Level&quot; to create your first level.</p>
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="levels-list">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className="space-y-2">
            {levels.map((level, index) => (
              <LevelItem
                key={level._id}
                level={level}
                index={index}
                isLoading={isLoading}
                onRemove={onRemove}
                onInput={onInput}
                setHasError={setHasError}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

LevelsList.propTypes = {
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      isNew: PropTypes.bool,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  setHasError: PropTypes.func.isRequired,
};

export default LevelsList;
